export default __webpack_public_path__ + "static/media/ÐÐµÐ·ÑÐ¼ÑÐ½Ð½ÑÐ¹.19c59f79.jpg";